module.exports = __webpack_public_path__ + "img/structures.86f4735c.jpg";